import React, { useState, useEffect } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import Location from "./Location";
import {
  fetchAsynApplicationStepData,
  fetchAsynUserIdentification,
  fetchAsynUserinformation,
  getCurrentStepData,
  getUserIdentification,
  getUserInformation,
} from "../../redux/transactions/UntappedSlice";
import { useDispatch, useSelector } from "react-redux";
import { set } from "lodash";

const GuarantorForm = ({ data, bikeType, onChange }) => {
  const dispatch = useDispatch();
  // Initial guarantor structure
  const initialGuarantors = {
    insurer_one: {
      guarantorPosition: "",
      phoneNumber: "",
      firstName: "",
      middleName: "",
      lastName: "",
      nationalId: "",
      occupation: "",
      province: "",
      district: "",
      sector: "",
      village: "",
    },
    insurer_two: {
      guarantorPosition: "",
      phoneNumber: "",
      firstName: "",
      middleName: "",
      lastName: "",
      nationalId: "",
      occupation: "",
      province: "",
      district: "",
      sector: "",
      village: "",
    },
  };

  const [guarantorsData, setGuarantorsData] = useState(initialGuarantors);
  const isElectricBike = bikeType === "ELECTRIC";
  const userInformation = useSelector(getUserInformation);

  const userIdentification = useSelector(getUserIdentification);

  const [uploadedFile, setuploadedFile] = useState("");
  const [uploadedIDFile, setuploadedIDFile] = useState("");

  const [file_YELLOW_CARD, setfile_YELLOW_CARD] = useState("");
  const [file_CONTRACT, setfile_CONTRACT] = useState("");
  const [file_BUSINESS_CERTIFICATE, setfile_BUSINESS_CERTIFICATE] =useState("");

 const phoneNumber = useSelector((state) => state.untapped.phoneNumber);
  const currentStepSavedData = useSelector(getCurrentStepData);


   useEffect(() => {
      if (phoneNumber?.trim().length === 10) {
        dispatch(
          fetchAsynApplicationStepData({ phone: phoneNumber.trim(), step: 5 })
        );
      }
    }, [dispatch, phoneNumber]);
    
// Sync formData with `data`, ensuring all fields remain controlled
useEffect(() => {
  // Early return if no saved data or no insurer_one in step_data
  if (!currentStepSavedData?.step_data?.insurer_one) return;

  // Destructure insurer_one data
  const insurerOne = currentStepSavedData.step_data.insurer_one;
  const residence = insurerOne.residence || {};
  const village = residence.village || {};
  const cells = village.cells || {};
  const sector = cells.sector || {};
  const district = sector.district || {};
  const province = district.province || {};

  // Update guarantors data
  setGuarantorsData((prev) => ({
    ...prev,
    insurer_one: {
      // Preserve existing data with spread operator
      ...prev.insurer_one,
      // Map directly from the data structure
      guarantorPosition: "MOTARD", // You may want to adjust this
      phoneNumber: insurerOne.phone || "",
      firstName: insurerOne.first_name || "",
      lastName: insurerOne.last_name || "",
      nationalId: insurerOne.identity || "",
      occupation: insurerOne.occupation || "",
      gender: insurerOne.gender || "",
      
      // Nested location data
      province: province.id || "",
      provinceName: province.name || "",
      district: district.id || "",
      districtName: district.name || "",
      sector: sector.id || "",
      sectorName: sector.name || "",
      cell: cells.id || "",
      cellName: cells.name || "",
      village: village.id || "",
      villageName: village.name || "",
    },
  }));
}, [currentStepSavedData]);


  useEffect(() => {
    if (userInformation && userIdentification) {
      updateGuarantor("insurer_one", userInformation, userIdentification);
    }
  }, [userInformation, userIdentification]);

  const updateGuarantor = (guarantorKey, userInfo, userId) => {
    setGuarantorsData((prev) => ({
      ...prev,
      [guarantorKey]: {
        ...prev[guarantorKey],
        firstName: userInfo?.firstname ?? "",
        middleName: userInfo?.middleName ?? "",
        lastName: userInfo?.lastname ?? "",
        nationalId: userId?.nid ?? "",
      },
    }));
  };

  useEffect(() => {
    const phoneNumber = guarantorsData?.insurer_one?.phoneNumber;

    if (phoneNumber?.length === 10) {
      dispatch(fetchAsynUserIdentification({ contact: phoneNumber }));
      dispatch(fetchAsynUserinformation({ contact: phoneNumber }));
    }
  }, [dispatch, guarantorsData?.insurer_one?.phoneNumber]);

  useEffect(() => {
    if (data) {
      const filteredData = {
        insurer_one: {
          ...data.insurer_one
        },
        insurer_two: {
          ...data.insurer_two
        },
      };

      setGuarantorsData(filteredData);
    }
  }, [data]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (JSON.stringify(guarantorsData) !== JSON.stringify(data)) {
        onChange({ guarantorsData, uploadedFile, uploadedIDFile, file_YELLOW_CARD, file_CONTRACT, file_BUSINESS_CERTIFICATE });
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [guarantorsData, data, onChange, uploadedFile, uploadedIDFile, file_YELLOW_CARD, file_CONTRACT, file_BUSINESS_CERTIFICATE]);

  const handleInputChange = (insurerType, e) => {
    const { name, value } = e.target;
    setGuarantorsData((prevData) => ({
      ...prevData,
      [insurerType]: {
        ...prevData[insurerType],
        [name]: value,
      },
    }));
  };

  const validateFile = (file) => {
    const isPDF = file.type === "application/pdf";
    const isSmallEnough = file.size / 1024 / 1024 < 1;

    if (!isPDF) message.error(`${file.name} is not a PDF file!`);
    if (!isSmallEnough)
      message.error(`${file.name} exceeds the 1MB size limit!`);
    return isPDF && isSmallEnough;
  };

  const convertFileToBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result);
    reader.onerror = (error) => console.error("Error converting file:", error);
  };

  const handleFileChange = (insurerType, info) => {
    const {file,fileList} = info;
    const guarantorPositionName =
      guarantorsData[insurerType]?.guarantorPosition || insurerType;

    if (file.status !== "removed") {
      if (guarantorPositionName === "UMUKOZI") {
        setfile_CONTRACT(fileList[1]);
        setfile_YELLOW_CARD('');
        setfile_BUSINESS_CERTIFICATE('');
      } else if (guarantorPositionName === "MOTARD") {
        setfile_YELLOW_CARD(fileList[1]);
        setfile_CONTRACT('');
        setfile_BUSINESS_CERTIFICATE('');
      } else if (guarantorPositionName === "UMUCURUZI") {
        setfile_BUSINESS_CERTIFICATE(fileList[1]);
        setfile_CONTRACT('');
        setfile_YELLOW_CARD('');
      }
      convertFileToBase64(file.originFileObj || file, (base64File) => {
        localStorage.setItem(`${guarantorPositionName}`, base64File);

        setGuarantorsData((prevData) => ({
          ...prevData,
          [insurerType]: {
            ...prevData[insurerType],
            uploadedFile: file.originFileObj || file,
          },
        }));

        message.success(`${file.name} has been added successfully.`);
      });
    } else {
      setuploadedFile("");
      localStorage.removeItem(`${guarantorPositionName}`);
      setGuarantorsData((prevData) => ({
        ...prevData,
        [insurerType]: {
          ...prevData[insurerType],
          uploadedFile: null,
        },
      }));
    }
  };



  // 5182662-3EE61C6A54
  const handleIdFileChange = (insurerType, info) => {
    const { file } = info;

    const guarantorPositionName =
      guarantorsData[insurerType]?.guarantorPosition || insurerType;

    if (file.status !== "removed") {
      setuploadedIDFile(file);
      convertFileToBase64(file.originFileObj || file, (base64File) => {
        localStorage.setItem(`${insurerType}_uploadedIDFile`, base64File);

        setGuarantorsData((prevData) => ({
          ...prevData,
          [insurerType]: {
            ...prevData[insurerType],
            uploadedIDFile: file.originFileObj || file,
          },
        }));

        message.success(`${file.name} has been added successfully.`);
      });
    } else {
      setuploadedIDFile("");
      localStorage.removeItem(`${insurerType}_uploadedIDFile`);
      setGuarantorsData((prevData) => ({
        ...prevData,
        [insurerType]: {
          ...prevData[insurerType],
          uploadedIDFile: null,
        },
      }));
    }
  };

  const renderFileUploadLabel = (position) => {
    switch (position) {
      case "MOTARD":
        return "Injiza carte jaune";
      case "UMUKOZI":
        return "Injiza contract";
      case "UMUCURUZI":
        return "Injiza icyemezo cy'ubucuruzi";
      default:
        return "";
    }
  };

  const updatedLocation = (insurerType, location) => {
    setGuarantorsData((prevData) => ({
      ...prevData,
      [insurerType]: {
        ...prevData[insurerType],
        ...location,
      },
    }));
  };

  const renderGuarantorForm = (insurerType, title) => {
    const guarantorData = guarantorsData[insurerType];
    const fileList = guarantorData.uploadedFile
      ? [guarantorData.uploadedFile]
      : [];
    const idFileList = guarantorData.uploadedIDFile
      ? [guarantorData.uploadedIDFile]
      : [];

    return (
      <div className="rounded-lg p-4 mb-4">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium">
              Umwishingizi wawe ari mukihe cyiciro
            </label>
            <select
              name="guarantorPosition"
              value={guarantorData.guarantorPosition}
              onChange={(e) => handleInputChange(insurerType, e)}
              className="w-full px-3 py-2 focus:outline-none border dark:border-gray-700 rounded-lg bg-gray-300 text-black"
            >
              <option value="" disabled>
                Hitamo
              </option>
              <option value="UMUKOZI">UMUKOZI</option>
              <option value="MOTARD">MOTARD</option>
              <option value="UMUCURUZI">UMUCURUZI</option>
              <option value="MOTO Y'AMASHANYARAZI">MOTO Y'AMASHANYARAZI</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium">
              Nimero ya telefone
            </label>
            <input
              name="phoneNumber"
              type="text"
              placeholder="078..."
              value={guarantorData.phoneNumber}
              onChange={(e) => handleInputChange(insurerType, e)}
              className="w-full px-3 py-2 focus:outline-none border dark:border-gray-700 rounded-lg bg-gray-300 text-black"
            />
          </div>
        </div>

        {guarantorData.guarantorPosition &&
          guarantorData.guarantorPosition !== "MOTO Y'AMASHANYARAZI" && (
            <div className="w-full border flex items-center justify-between mt-3 rounded-md p-2">
              <label className="block text-sm font-medium mx-3">
                {renderFileUploadLabel(guarantorData.guarantorPosition)}
              </label>
              <Upload
                fileList={fileList}
                customRequest={({ onSuccess }) => onSuccess("ok")}
                beforeUpload={(file) => {
                  if (!validateFile(file)) return Upload.LIST_IGNORE;
                  return false;
                }}
                onChange={(info) => handleFileChange(insurerType, info)}
              >
                <Button className="text-white" icon={<UploadOutlined />}>
                  Choose File
                </Button>
              </Upload>
            </div>
          )}

        <div className="w-full border flex items-center justify-between mt-3 rounded-md p-2">
          <label className="block text-sm font-medium mx-3">
            Injiza Indangamuntu
          </label>
          <Upload
            fileList={idFileList}
            customRequest={({ onSuccess }) => onSuccess("ok")}
            beforeUpload={(file) => {
              if (!validateFile(file)) return Upload.LIST_IGNORE;
              return false;
            }}
            onChange={(info) => handleIdFileChange(insurerType, info)}
          >
            <Button className="text-white" icon={<UploadOutlined />}>
              Choose File
            </Button>
          </Upload>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-4">
          {["firstName", "middleName", "lastName"].map((field) => (
            <div key={field}>
              <label className="block text-sm font-medium">
                {field === "firstName"
                  ? "Izina ribanza"
                  : field === "middleName"
                  ? "Izina ryo hagati"
                  : "Irindi zina"}
              </label>
              <input
                name={field}
                type="text"
                placeholder={
                  field === "firstName"
                    ? "Izina ribanza"
                    : field === "middleName"
                    ? "Izina ryo hagati"
                    : "Irindi zina"
                }
                value={guarantorData[field]}
                onChange={(e) => handleInputChange(insurerType, e)}
                className="w-full px-3 py-2 focus:outline-none border dark:border-gray-700 rounded-lg bg-gray-300 text-black"
              />
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-sm font-medium">
              Nimero y'irangamuntu
            </label>
            <input
              name="nationalId"
              type="number"
              placeholder="Nimero y'irangamuntu"
              value={guarantorData.nationalId}
              onChange={(e) => handleInputChange(insurerType, e)}
              className="w-full px-3 py-2 focus:outline-none border dark:border-gray-700 rounded-lg bg-gray-300 text-black"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Icyo akora</label>
            <input
              name="occupation"
              type="text"
              placeholder="Icyo akora"
              value={guarantorData.occupation}
              onChange={(e) => handleInputChange(insurerType, e)}
              className="w-full px-3 py-2 focus:outline-none border dark:border-gray-700 rounded-lg bg-gray-300 text-black"
            />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">
            Aho umwishingizi atuye
          </label>
          <Location
            province={guarantorData.province}
            district={guarantorData.district}
            sector={guarantorData.sector}
            cell={guarantorData.cell}
            village={guarantorData.village}
            onLocationChange={(location) =>
              updatedLocation(insurerType, location)
            }
          />
        </div>
      </div>
    );
  };

  return (
    <form className="space-y-4">
      {renderGuarantorForm("insurer_one", "Umwishingizi wa mbere")}
      {isElectricBike &&
        renderGuarantorForm("insurer_two", "Umwishingizi wa kabiri")}
    </form>
  );
};

export default GuarantorForm;
